var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 1C13 0.447715 12.5523 0 12 0H1C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2H12C12.5523 2 13 1.55228 13 1Z",
    fill: "#545E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0 4.44772 0.447715 4 1 4H8C8.55229 4 9 4.44772 9 5C9 5.55228 8.55229 6 8 6H1C0.447715 6 0 5.55228 0 5Z",
    fill: "#545E6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9C6 8.44771 5.55228 8 5 8H1C0.447715 8 0 8.44771 0 9C0 9.55229 0.447715 10 1 10H5C5.55228 10 6 9.55229 6 9Z",
    fill: "#545E6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 13C3 12.4477 2.55228 12 2 12H1C0.447715 12 0 12.4477 0 13C0 13.5523 0.447715 14 1 14H2C2.55228 14 3 13.5523 3 13Z",
    fill: "#545E6B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5V12.5757L14.2556 11.3033C14.6546 10.8989 15.3016 10.8989 15.7007 11.3033C16.0998 11.7077 16.0998 12.3634 15.7007 12.7678L12.8104 15.6967C12.5885 15.9216 12.29 16.0214 12 15.9962C11.71 16.0214 11.4115 15.9216 11.1896 15.6967L8.2993 12.7678C7.90023 12.3634 7.90023 11.7077 8.2993 11.3033C8.69836 10.8989 9.34537 10.8989 9.74444 11.3033L11 12.5757V5Z",
    fill: "#545E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescending);
export default __webpack_public_path__ + "static/media/descending.eb61ecccf18500e161553e19ca2d561d.svg";
export { ForwardRef as ReactComponent };